import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { XCircle, ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';

const CheckoutCancel = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-4 pt-16" data-testid="checkout-cancel-page">
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5 }}
        className="max-w-md w-full"
      >
        <div className="bg-background-paper rounded-2xl shadow-xl p-8 text-center border border-primary/20">
          <div className="mb-6">
            <XCircle className="w-20 h-20 text-text-muted mx-auto" data-testid="cancel-icon" />
          </div>
          <h1 className="text-3xl font-heading font-bold text-white mb-4" data-testid="cancel-title">Checkout Cancelled</h1>
          <p className="text-text-secondary font-body mb-8" data-testid="cancel-message">
            Your payment was cancelled. No charges have been made to your account. Your items are still in your cart if you'd like to try again.
          </p>
          <div className="space-y-3">
            <Button
              onClick={() => navigate('/cart')}
              className="w-full bg-primary hover:bg-primary-hover text-white rounded-full py-3 text-lg shadow-lg shadow-primary/30 hover:shadow-primary/50 button-primary"
              data-testid="return-to-cart-button"
            >
              <ArrowLeft className="w-5 h-5 mr-2" />
              Return to Cart
            </Button>
            <Button
              onClick={() => navigate('/products')}
              variant="outline"
              className="w-full border-2 border-white/20 text-white hover:bg-white/5 hover:border-primary rounded-full py-3"
              data-testid="continue-shopping-cancel-button"
            >
              Continue Shopping
            </Button>
          </div>
        </div>
      </motion.div>
    </div>
  );
};

export default CheckoutCancel;
